import { useRef } from 'react';
import clsx from 'clsx';
import { HashRouter } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import { getAmpConfigFlags } from 'shared/config/amp-config';
import { Navigation } from 'shared/ui/navigation';
import { useMouseDetect } from 'shared/lib/utils';
// eslint-disable-next-line boundaries/element-types
import {
  AcceptedInviteAlert,
  useAcceptInvite,
  useIsAcceptedInviteAlertVisibleSelector,
} from 'features/accepted-invite-alert';

import styles from './styles.module.scss';

export const NycDoeError = () => {
  const { t } = useTranslation();
  const appRef = useRef<HTMLDivElement>(null);

  const isAcceptedInviteAlertVisible =
    useIsAcceptedInviteAlertVisibleSelector();

  const { isNewNavigationEnabled } = getAmpConfigFlags();

  useMouseDetect(appRef);
  useAcceptInvite();

  return (
    <section
      ref={appRef}
      className={clsx(
        'd-flex',
        'flex-column',
        'justify-content-center',
        'align-items-center',
        'page',
        'error-screen-wrap',
        {
          'error-screen-wrap-new-nav': isNewNavigationEnabled,
        },
      )}
    >
      {!isNewNavigationEnabled && (
        <HashRouter>
          <Navigation />
        </HashRouter>
      )}
      {isAcceptedInviteAlertVisible && (
        <div className="error-screen-accept-invite-message">
          <AcceptedInviteAlert />
        </div>
      )}
      <div
        className={clsx(styles.info, {
          [styles.infoWithNewNav]: isNewNavigationEnabled,
        })}
      >
        <p className={styles.text}>
          <Trans
            t={t}
            // eslint-disable-next-line max-len
            i18nKey="<b>Your programs are not set up.</b><br />Please contact your principal to inquire<br />who is responsible for setting up schedules in STARS<br />and ensuring all classes are finalized."
            components={{ b: <b />, br: <br /> }}
          />
        </p>
      </div>
    </section>
  );
};
